export default __webpack_public_path__ + "static/media/occamx-bg.d2d25a26.jpg";